// extracted by mini-css-extract-plugin
module.exports = {"image-thumb":"ImageThumb_image-thumb__3dWxM","image-thumb-text":"ImageThumb_image-thumb-text__1Ew7B","image-thumb-textbox":"ImageThumb_image-thumb-textbox__3Xv8m"};